<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    width="35%"
    @close="handleClose"
  >
    <el-form :model="emailForm" :rules="rules" ref="forms" label-width="120px">
      <template v-if="status === 0">
        <el-form-item :label="this.$t('center.email')" prop="email">
          <el-input
            v-model="emailForm.email"
            :placeholder="this.$t('center.plaEmail')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('center.code')" prop="code">
          <el-input v-model="emailForm.code">
            <template slot="append">
              <el-button
                type="primary"
                @click="getEmailCode"
                v-if="timer === null"
                >{{ $t('center.getCode') }}
              </el-button>
              <el-button type="info" v-else>{{ count }} s</el-button>
            </template>
          </el-input>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item :label="this.$t('center.email')" prop="email">
          <el-input
            v-model="emailForm.email"
            :placeholder="this.$t('center.plaEmail')"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('center.code')" prop="code">
          <el-input v-model="emailForm.code">
            <template slot="append">
              <el-button
                type="primary"
                @click="getVerEmailCode"
                v-if="timer === null"
                >{{ $t('center.getCode') }}
              </el-button>
              <el-button type="info" v-else>{{ count }} s</el-button>
            </template>
          </el-input>
        </el-form-item>
      </template>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submit">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import timing from '@/components/timing'
import { validatorEmailRule } from '@/utils/validatorRule.js'
import * as companyApi from '@/services/companyApi'
import { getEmailCode } from '@/services/userCenter.js'
export default {
  components: { timing },
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    status: {
      type: [Number, String]
    },
    userInfo: {
      type: Array
    }
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val) {
          this.isFormatEmail()
        }
      },
      immediate: true
    }
  },
  data() {
    let checkBind = (rule, value, callback) => {
      let params = {
        content: value,
        type: 1
      }
      companyApi.checkBindPhoneOrEmail(params).then(data => {
        if (data.code === '00000000') {
          return callback()
        } else {
          return callback(new Error(this.$t('common.alreadyBindEmail')))
        }
      })
    }
    return {
      emailForm: {
        email: '',
        code: ''
      },
      count: 60,
      timer: null,
      rules: {
        email: validatorEmailRule(true, checkBind),
        code: this.validatorInputEmptyRule(true)
      }
    }
  },
  methods: {
    isFormatEmail() {
      let temp = JSON.parse(JSON.stringify(this.userInfo))
      if (temp.emailState !== undefined && temp.emailState !== '0') {
        // 绑定再回显
        this.emailForm.email = this.emailFormat(temp.email)
      }
    },
    handleClose() {
      this.$emit('closeEmail')
      this.$refs.forms.resetFields()
      this.count = 60
      clearInterval(this.timer)
      this.timer = null
    },
    init() {
      this.emailForm.email = ''
      this.emailForm.code = ''
      this.count = 60
      clearInterval(this.timer)
      this.timer = null
    },
    submit() {
      let temp = Object.assign({}, this.emailForm)
      if (this.status === 1) {
        temp.email = this.userInfo.email
      }
      this.$emit('submitEmail', temp)
    },
    beginTiming() {
      this.timer = setInterval(() => {
        this.count--
        if (this.count === 0) {
          this.count = 60
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    sendCode(params) {
      getEmailCode(params).then(data => {
        if (data.code === '00000000') {
          this.beginTiming()
        } else if (data.code === 'E0010351') {
          this.$message({
            message: data.message,
            type: 'warning'
          })
        } else {
          this.errorMessage(data.message)
        }
      })
    },
    getVerEmailCode() {
      if (this.count === 60) {
        let params = {
          email: this.userInfo.email, //   'ryan.lu@zkteco.com'
          type: 'checkEmail'
        }
        this.sendCode(params) // 身份验证
      }
    },
    getEmailCode() {
      if (this.count === 60) {
        this.$refs.forms.validateField('email', errorEmail => {
          if (!errorEmail) {
            // 发送验证码接口 绑定
            let params = {
              email: this.emailForm.email,
              type: 'bindEmail'
            }
            this.sendCode(params)
          } else {
            return false
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/modules/personCenter/dialog/emailDialog.vue